// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const composeClasses = className => className ?
    `labeled-string ${className}` :
    'labeled-string';

const LabeledString = props =>
    <div className={composeClasses(props.className)}>
        <span className='data-label'>
            {props.shouldTranslate ?
                <FormattedMessage
                    id={props.label}
                    values={props.values}
                /> :
                props.label
            }
        </span>
        <span className='data-key'>{props.data}</span>
    </div>;

LabeledString.displayName = 'LabeledString';
LabeledString.propTypes = {
    className: PropTypes.string,
    data: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    shouldTranslate: PropTypes.bool,
    values: PropTypes.object
};

LabeledString.defaultProps = {
    shouldTranslate: true
};

export default LabeledString;



// WEBPACK FOOTER //
// ./src/shared/components/labeled-string/index.js